import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoSegundaViaExameDeOrdemConfig = {
  id: 'pedido_SegundaViaExameDeOrdem',
  nome: 'Pedido de 2ª Via do Exame De Ordem',
  categoria: 'pedidos',
  descricao: 'Solicitação da 2ª Via do Exame De Ordem OAB/MS',
  icon: 'FaTrashAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento preenchido e assinado digitalmente', 
        required: true 
      }
    ],
  },

  paymentConfig: {
    amount: 27.00
  },

  protocoloConfig: {
    modeloRequerimento: '243',
    tiposAssunto: '655',
    tipoPedido: '401'
  },

  tituloConfig: {
    tipoLancamentoId: 94,
    enderecoOrigem: 'residencial'
  },

  // Confirmado ao vivo via GET /modelo-requerimento/243/campos.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoSegundaViaExameDeOrdemConfig;